import { render, staticRenderFns } from "./EquipamentoEnviarDadoAvulso.vue?vue&type=template&id=6668aa7b&scoped=true&"
import script from "./EquipamentoEnviarDadoAvulso.vue?vue&type=script&lang=js&"
export * from "./EquipamentoEnviarDadoAvulso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668aa7b",
  null
  
)

export default component.exports